import { gql, TypedDocumentNode } from '@common/hooks';
import {
  BillingCardLogQueryVariables,
  BillingCardLogQueryCgResponse,
} from '@common/graphql/schema';
import { BillingCardFragment } from '@institutions/graphql';

export type BillingCardLogType =
  BillingCardLogQueryCgResponse['billingCardLog'];

export type BillingCardType = BillingCardLogType['billingCards'][number];

export const BillingCardLogQuery: TypedDocumentNode<
  BillingCardLogQueryCgResponse,
  BillingCardLogQueryVariables
> = gql`
  query BillingCardLog(
    $organizationUnitId: ID!
    $roleId: ID!
    $roleLevel: RoleLevelEnum!
  ) {
    billingCardLog(
      organizationUnitId: $organizationUnitId
      roleId: $roleId
      roleLevel: $roleLevel
    ) {
      organizationUnit {
        id
        name
        department {
          id
          organizationBusiness {
            id
            name
          }
        }
        clinicalUnit {
          id
          displayName
        }
      }
      role {
        id
        name
        abbreviation
      }
      roleLevel
      billingCards {
        name
        serial
        effectiveDate
        createdAt
        createdBy {
          id
          name
        }
        ...BillingCardFragment
      }
    }
  }
  ${BillingCardFragment}
`;
